import React, {PropsWithChildren, type HTMLAttributes} from 'react';
import clsx from 'clsx';

import styles from './row.module.css';
import { Spacing } from '@/utils/types';

export type RowProps = {
  scrollable?: boolean,
  desktopScrollable?: boolean,
  sDirectionCol?: boolean,
  directionCol?: boolean,
  noGap?: boolean,
  wrap?: boolean,
  sWrap?: boolean,
  dWrap?: boolean,
  gap?: Spacing,
  sGap?: Spacing,
} & HTMLAttributes<HTMLElement> & PropsWithChildren

export const Row = ({scrollable, desktopScrollable, directionCol, sDirectionCol, noGap, wrap, sWrap, gap, sGap, dWrap, children, className, ...props}: RowProps)=> {
  return (
    <div className={clsx(
      styles.row,
      scrollable && styles.scrollable,
      desktopScrollable && styles.desktopScrollable,
      sDirectionCol && styles.sDirectionCol,
      directionCol && styles.directionCol,
      noGap && styles.noGap,
      wrap && styles.wrap,
      dWrap && styles.dWrap,
      className)}
      {...(gap || sGap ? {
        style: {
          ...(gap ? {'--gap': `var(--spacing-${gap})`} : {}),
          ...(sGap ? {'--sGap': `var(--spacing-${sGap})`} : {})
        } as React.CSSProperties
      } : {})}
      {...props}>
      {children}
    </div>
  )
};
